<script>
import { required } from 'vuelidate/lib/validators'
import EventDetails from './event_entry'
import axios from 'axios'

export default {
	components: { EventDetails },
	props: {
		url: {
			type: String,
			default: '/office365/events/list?limit=100',
		}
	},
	data() {
		return {
			appConfig: {},
			category: 'List',
			items: [
				{
					text: 'Inicio',
					href: '/',
				},
				{
					text: 'Eventos de Office 365',
					active: true,
				},
			],
			// eslint-disable-next-line
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			event: {},
			events: [],
			tableData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: '',
			// filterOn: [],
			sortBy: 'CreationTime',
			sortDesc: true,
			fields: [
		    { key: 'CreationTime', label: 'Creation Time', sortable: true },
				{ key: 'UserId', label: 'User', sortable: true },
				{ key: 'Operation', label: 'Operation', sortable: true },
				{ key: 'ResultStatus', label: 'Result Status', sortable: true },
				{ key: 'ClientIP', label: 'IP', sortable: true },
				{ key: 'Location', label: 'Location', sortable: true },
				{ key: 'action', label: 'Action', sortable: false },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.totalRows || 0
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		loadData (src='') {
			let that = this
			that.isBusy = true
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			const countURL =  (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&rawsearch=${src}&count=yes`

			axios.get(countURL)
			.then((response) => {
				that.totalRows = parseInt(response.data)
			})
			// eslint-disable-next-line
			.catch(function (error) {
				// eslint-disable-next-line
				return
			}) 
			const dataURL = (src.length < 1 ) ? 
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&altorder=CreationTime` :
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&altorder=CreationTime&rawsearch=${src}`
			axios.get(dataURL).then((response) => {
				if (response.status === 200) {
					that.events = response.data
					that.tableData = response.data.map(function(entry){
						return {
							Id: entry.Id !== undefined ? entry.Id : '',
							UserId: entry.UserId || "",
							CreationTime: new Date(entry.CreationTime['$date']).toLocaleString() || '',
							ClientIP: entry.ClientIP || "",
							Operation: entry.Operation || "",
							ResultStatus: entry.ResultStatus || "",
							Location:  entry.intelligence !== undefined && entry.intelligence.geoip !== undefined 
								? (entry.intelligence.geoip.location.country_flag_emoji || '') + ' ' + entry.intelligence.geoip.city + ', ' + entry.intelligence.geoip.country_name : "",
							ThreatLevel: entry.intelligence !== undefined && entry.intelligence.geoip !== undefined && entry.intelligence.geoip.security !== undefined
								? (entry.intelligence.geoip.security.threat_level || '') : '',
							LogonError: entry.LogonError || ""
						}
					})
				}
				that.isBusy = false
			})
			.catch(function (error) {
				console.log(error)
			}) 
		},
		showDetails (id) {
			if (id === undefined) return
			this.event = {}
			this.event = this.events.find(entry => entry.Id === id)
			console.log('event all', this.event)
			this.$refs['modal-details'].show()
		},
    modalDetailOk() {

    },
		doSearch() {
			let filter = this.filter
			if (filter.length !== undefined) {
				this.loadData(filter)
			}
		}
	},
	watch: {
		currentPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
		perPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
	}
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Eventos encontrados: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Text to search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
						<b-button size="sm" variant="light" @click="doSearch">
							Búsqueda
						</b-button>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="0"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:totalRows="totalRows"
				:pagination-options="{
					enabled: true,
				}"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>


				<template v-slot:cell(ResultStatus)="data">
					<template v-if="['Success','Succeeded'].includes(data.item.ResultStatus)">
						<span style="color: green;">
							{{ data.item.ResultStatus }}
						</span>
					</template>
					<template v-else-if="['Fail','Failed'].includes(data.item.ResultStatus)">
						<span style="color: red;">
							{{ data.item.ResultStatus }}
						</span>
					</template>
					<template v-else>
						{{ data.item.ResultStatus }}
					</template>
				</template>

				<template v-slot:cell(ClientIP)="data">
					<!-- <template v-if="data.item.ThreatLevel === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.ThreatLevel === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else-if="data.item.ThreatLevel === 'high'">
						<feather type="alert-triangle" class="icon-xs icon-dual-danger"></feather>
					</template>
					<template v-else>
						<feather type="alert-triangle" class="icon-xs icon-dual-danger"></feather>
					</template> -->
					<template v-if="data.item.ThreatLevel === 'low'">
						<span style="color: green;">
							{{ data.item.ClientIP }}
						</span>
					</template>
					<template v-else-if="data.item.ThreatLevel === 'medium'">
						<span style="color: orange;">
							{{ data.item.ClientIP }}
						</span>
					</template>
					<template v-else-if="data.item.ThreatLevel === 'high'">
						<span style="color: red;">
							{{ data.item.ClientIP }}
						</span>
					</template>
					<template v-else>
						{{ data.item.ClientIP }}
					</template>
				</template>

				<template v-slot:cell(action)="data">
					<b-dropdown right variant="white" class="align-self-center" toggle-class="p-0">
						<template v-slot:button-content>
							<feather type="chevron-down" class="align-middle" style="height:12px !important;width:20px !important;"></feather>
						</template>
						<b-dropdown-item @click="showDetails(data.item.Id)" class="notify-item">
							<feather
								type="search"
								class="icon-dual icon-xs mr-2 align-middle"
							></feather>
							<span>Details</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
		<b-modal
			id="incident.incident_id"
			ref="modal-details"
			size="xl"
			title="Event Details"
			:centered=true
			:no-fade=true
			ok-only
      @ok="modalDetailOk">
			<EventDetails :event="event" />
		</b-modal>
		<!-- <b-modal
			ref="modal-details"
			id="incident.incident_id"
			size="xl"
			title="Incident Details"
			:centered=true
			:no-fade=true
      @ok="modalIncidentDetailOk"
			ok-only>
			<div role="tablist" class="custom-accordionwitharrow">
				<template v-if="assets !== undefined && assets.length > 0">
					<a href="#" class="text-dark" v-b-toggle.collapse-assets>
						<h5 class="mb-0">
							<feather type="chevron-down" class="align-middle"></feather>
							Assets
							<span class="text-muted font-size-14">({{ assets.length }})</span>
						</h5>
					</a>
					<b-collapse visible id="collapse-assets">
						<Assets :assetsData="assets" />
					</b-collapse>
				</template>

        <template v-if="netinfo !== undefined && netinfo.length > 0">
          <a href="#" class="text-dark" v-b-toggle.collapse-assets>
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle"></feather>
              Involved Network Segments
              <span class="text-muted font-size-14">({{ netinfo.length }})</span>
            </h5>
          </a>
          <b-collapse visible id="collapse-assets">
            <NetInfos :netinfoData="netinfo" />
          </b-collapse>
        </template>

				<template v-if="incident.alerts !== undefined && incident.alerts.total_count > 0">
					<a href="#" class="text-dark" v-b-toggle.collapse-alerts>
						<h5 class="mb-0">
							<feather type="chevron-down" class="align-middle"></feather>
							Alerts
							<span class="text-muted font-size-14">({{ incident.alerts.total_count }})</span>
						</h5>
					</a>
					<b-collapse visible id="collapse-alerts">
						<Alerts :alertsData="incident.alerts.data" />
					</b-collapse>
				</template>

				<template v-if="indicatorsNet !== undefined && indicatorsNet.length > 0">
					<b-card no-body class="mb-1 border shadow-none">
						<b-card-header header-tag="header" role="tab">
							<a href="javascript: void(0);" class="text-black">
								<h5 v-b-toggle.accordion-2 class="m-0 font-size-16"
									>Network Artifacts</h5
								>
							</a>
						</b-card-header>
						<b-collapse
							id="accordion-2"
							accordion="my-accordion"
							role="tabpanel"
						>
							<b-card-body>
								<b-card-text v-for="nartifacts in indicatorsNet">
									{{ nartifacts }}
								</b-card-text>
							</b-card-body>
						</b-collapse>
					</b-card>
				</template>

				<template v-if="indicatorsFile !== undefined && indicatorsFile.length > 0">
					<a href="#" class="text-dark" v-b-toggle.collapse-files>
						<h5 class="mb-0">
							<feather type="chevron-down" class="align-middle"></feather>
							Files
							<span class="text-muted font-size-14">({{ indicatorsFile.length }})</span>
						</h5>
					</a>
						<b-collapse id="collapse-files">
							<Files :indicatorsFile=indicatorsFile />
						</b-collapse>
				</template>
			</div>
		</b-modal> -->
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>